import toastMessage from "../toastMessage";
import { getStorage } from "../storage";
import api from "../api";

const API_URL = process.env.REACT_APP_BBMS_BASE_API;

const fetchHemovigilancePlan = async (lng = "english", params = {}) => {
  try {
    const user = await getStorage();
    const res = await api({
      method: "GET",
      url: `${API_URL}/hemovigilancePlan`,
      params,
      headers: { Authorization: `Bearer ${user.token}` },
    });
    return res.data;
  } catch (error) {
    toastMessage("error", "Unable to fetch hemovigilance plan");
  }
};

export const createHemovigilancePlan = async (lng = "english", body) => {
  const user = await getStorage();
  return api({
    method: "POST",
    url: `${API_URL}/hemovigilancePlan`,
    data: body,
    headers: { Authorization: `Bearer ${user.token}` },
  });
};

export const bulkCreateHemovigilancePlan = async (lng = "english", entries) => {
  const user = await getStorage();
  return api({
    method: "POST",
    url: `${API_URL}/hemovigilancePlan/bulk`,
    data: { entries },
    headers: { Authorization: `Bearer ${user.token}` },
  });
};

export const updateHemovigilancePlan = async (lng = "english", body) => {
  const user = await getStorage();
  return api({
    method: "PUT",
    url: `${API_URL}/hemovigilancePlan`,
    data: body,
    headers: { Authorization: `Bearer ${user.token}` },
  });
};

export const recordHemovigilancePerformance = async (lng = "english", body) => {
  const user = await getStorage();
  return api({
    method: "PUT",
    url: `${API_URL}/hemovigilancePlan/perform`,
    data: body,
    headers: { Authorization: `Bearer ${user.token}` },
  });
};

export const deleteHemovigilancePlan = async (lng = "english", id) => {
  const user = await getStorage();
  return api({
    method: "DELETE",
    url: `${API_URL}/hemovigilancePlan`,
    data: { id },
    headers: { Authorization: `Bearer ${user.token}` },
  });
};

export default fetchHemovigilancePlan;
